import Cookies from 'js-cookie'

/**
 * Saves an item to the browser cookies. The value could be of any type, it will be converted to the string
 * @param key - cookies key
 * @param value - value to be saved
 * @param options - cookie options including domain
 */
export const set = (key: string, value: unknown, options?: Cookies.CookieAttributes): void => {
  if (key.trim() !== '' && value !== undefined && value !== null) {
    try {
      const str = typeof value === 'string' ? value : JSON.stringify(value)
      Cookies.set(key, str, options)
    } catch (error) {
      const str = value as string
      Cookies.set(key, str, options)
    }
  }
}

/**
 * Gets an item from the browser cookies. The method will try to convert the result to a type with JSON.parse, in case convertion is not successfull the method will return a string.
 * @param key - cookies key
 * @returns unknown
 * @example const result = get('myKey') as boolean;
 */
export const get = (key: string): unknown => {
  if (key.trim() === '') {
    return undefined
  }

  const value = Cookies.get(key)
  if (value !== undefined) {
    try {
      const obj = JSON.parse(value) as unknown
      return obj
    } catch (error) {
      return value
    }
  }
  return undefined
}

/**
 * Removes an item from the cookies
 * @param key - cookies key
 * @param options - cookie options including domain
 */
export const remove = (key: string, options?: Cookies.CookieAttributes): void => {
  if (key.trim() !== '') {
    Cookies.remove(key, options)
  }
}
